import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PageContainer from '../../layout/PageContainer';
import LibrosVenta from './LibrosVenta';
import {
  API,
  BASE_URL,
  ROLES_ASEGURADO,
  ROLES_CORREDOR,
} from 'CONST';
import { userHasRole } from 'helpers/helpers';
import auth from 'helpers/auth';


const LibrosVentaContainer = ({ match: { params: { policyId }, url } }) => {
  const user = useSelector((state) => state.login.user);
  const [policyIdState, setPolicyIdState] = useState(policyId);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [loading, setLoading] = useState(typeof policyId === 'undefined');

  // Es asegurado únicamente, no es corredor
  const isAsegurado = userHasRole(user, ROLES_ASEGURADO) && !userHasRole(user, ROLES_CORREDOR);
  const isCorredor = userHasRole(user, ROLES_CORREDOR);
  const isCorrederRoute = url.startsWith('/corredor');

  const breadcrumbs = React.useMemo(() => {
    if (!isCorrederRoute) {
      if (isAsegurado) {
        return [{ id: 0, name: 'SEGURO DE CRÉDITO', url: '/' }, { id: 1, name: 'LIBROS DE VENTA' }];
      }
      return [
        { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        { id: 1, name: 'ASEGURADO', url: '/asegurado/polizas-credito' },
        { id: 2, name: 'LIBROS DE VENTA' },
      ];
    }

    return [
      { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
      { id: 1, name: 'CORREDOR', url: '/corredor/polizas-credito' },
      { id: 2, name: 'LIBROS DE VENTA' },
    ];
  }, [isAsegurado, isCorrederRoute]);

  useEffect(() => {
    if (typeof policyId !== 'undefined') return;

    const fetchData = async () => {
      try {
        if (isAsegurado) {
          const policies = await auth.fetch(`${BASE_URL}${API.simpleCreditos}/`);

          if (policies.length !== 1) {
            setShouldRedirect(true);
            return;
          }

          setPolicyIdState(policies[0].id.toString());
        } else if (isCorredor) {
          setShouldRedirect(true);
        } else if (!policyId) {
          setShouldRedirect(true);
        }
      } catch (error) {
        console.error('Error al obtener las polizas: ', error);
        setShouldRedirect(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [isAsegurado, isCorredor, policyId]);

  const redirectUrl = isCorrederRoute ? '/corredor/polizas-credito' : '/asegurado/polizas-credito';

  
  if (shouldRedirect) return <Redirect to={redirectUrl} />;

  return (
    <PageContainer
      breadcrumbs={breadcrumbs}
      clientFilter={{
        type: isCorrederRoute ? 'corredor' : 'asegurado',
        ramo: 'credito',
        showFilter: false,
      }}
    >
      {!loading && ((client) => (
        <LibrosVenta policyId={policyIdState} client={client} />
      ))}
    </PageContainer>
  );
}

LibrosVentaContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      policyId: PropTypes.string,
    }),
  }).isRequired,
};

export default LibrosVentaContainer;